import React from 'react'

import { ColorKinds, COLORS, KINDS, SIZES, SizesKinds, TabKinds } from './constants'
import { ValueType } from './types'

interface Props {
  size: SizesKinds
  color: ColorKinds
  kind: TabKinds
  stretch: boolean
  value?: ValueType
  onChange?: (value: ValueType) => void
  animation?: boolean
}

export const TabContext = React.createContext<Props>({ kind: KINDS.DEFAULT, color: COLORS.PRIMARY, size: SIZES.LARGE, stretch: false })
